import { datadogRum } from "@datadog/browser-rum";
import { environment } from "apps/web/src/environment";
import axios from "axios";

export const useFetchResource = () => {
  const fetchUrl = `${environment.VITE_URL_SCHEME}${environment.VITE_SERVER_DOMAIN}/fetch-education-resource`;

  const fetchResource = async (fileKey: string) => {
    try {
      const response = await axios.get(fetchUrl, {
        params: { fileKey },
        withCredentials: true,
      });
      return response.data;
    } catch (err) {
      datadogRum.addError(`User encountered error while fetching resource from the S3 bucket`, { err });
    }
  };
  return fetchResource;
};
